import * as xinjsui from './index'
import * as xinjs from 'tosijs'

Object.assign(globalThis, { xinjs, xinjsui })
